<template>
  <Layout>
    <div class="card">
      <div class="card-body">
        <PageHeader :title="title" :items="items" />
        <div class="form-row">
          <div class="form-group col-md-7">
            <label>Filtro de tipo</label>
            <v-select :options="expedientes_tipos"
                      label="descripcion"
                      v-model="filtro.expediente_tipo_id"
                      :reduce="descripcion=>descripcion.id"
                      @input="loadItems()"
            />
          </div>
          <div class="form-group col-md-5">
            <label>Filtro de escuela</label>
            <v-select
                    :options="carreras_profesionales"
                    label="carrera"
                    :reduce="carrera=>carrera.codigo"
                    v-model="filtro.codigo_carrera"
                    @input="loadItems()"
            />
          </div>
        </div>



        <vue-good-table
          ref="tblExpedientes"
          mode="remote"
          @on-page-change="onPageChange"
          @on-sort-change="onSortChange"
          @on-column-filter="onColumnFilter"
          @on-per-page-change="onPerPageChange"
          @on-search="onSearch"
          :totalRows="totalRecords"
          :isLoading.sync="isLoading"
          :pagination-options="{
            enabled: true
          }"
          :rows="rows"
          :columns="columns"
          :globalSearch="true"
          @on-row-dblclick="onRowDoubleClick"
          styleClass="vgt-table smalltable fixfont"
          :search-options="{
            enabled: true,
            //trigger: 'enter',
            skipDiacritics: true,
            placeholder: 'buscarEnTabla'
          }"
          :select-options="{
            selectOnCheckboxOnly: true,
            enabled: true,
            selectionText: 'Filas seleccionadas',
            clearSelectionText: 'Borrar'
          }"
          :sort-options="{
          enabled: false,
          }"
        >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'tipo_expediente'">
              <a href="javascript:void(0);" v-on:click="mostrarModal(props.row.id)">{{props.row.tipo_expediente}}</a>
            </span>
            <span v-else-if="props.column.field == 'denominacion'">
              <a href="javascript:void(0);" v-on:click="mostrarEstudiante(props.row)">{{props.row.denominacion}}</a>
            </span>

            <span v-else-if="props.column.field == 'archivos'">
              <div
                v-for="(data, index) in props.row.archivos"
                v-bind:key="index"
                style="float:left"
              >
                <a :href="server + '/storage/' + data.nombre" target="_blank" v-b-tooltip.top ="data.nombre_original" >
                  <i
                    class="mdi mdi-cloud-download ml-1"
                    style="font-size: 20px;color: #000000"
                /></a>
              </div>
            </span>
            <span v-else-if="props.column.field == 'acciones'">
              <button class="btn btn-outline-info m-1" v-on:click="recepcionarActual(props.row)" >
                Recep.
              </button>
              <button class="btn btn-outline-danger" v-on:click="mostrarModalRechazo(props.row.id)">
                Rechazar
              </button>
            </span>
            <span v-else class="fixfont">
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>

          <div slot="table-actions">
            <button
              type="button"
              class="btn btn-primary"
              v-on:click="recepcionarEnLote()"> Recepcionar en lote
            </button>
          </div>
        </vue-good-table>
        <b-modal
                id="modalExpediente"
                scrollable
                title="Expediente"
                title-class="font-18"
                size="xl"
        >
          <ExpedienteInfo :modal="modal" />

        </b-modal>
        <b-modal
                id="modalExpedientePreguntarRazon"
                scrollable
                title="Expediente"
                title-class="font-18"
                size="xl"
        >

            <ExpedientePreguntarRazon :modal="modal" :isLoading="isLoading" @change-text="updateText" />

          <template #modal-footer>
            <button class="btn btn-danger float-right" v-on:click="rechazarAEstudiante(modal.id)" :disabled="isLoading">
              Rechazar a estudiante / usuario
            </button>
            <button class="btn btn-primary float-right" v-on:click="rechazarAOficina(modal.id)" :disabled="isLoading">
              Rechazar a oficina
            </button>

          </template>
        </b-modal>
        <b-modal
                id="modalEstudiante"
                scrollable
                title="Estudiante"
                title-class="font-18"
                size="lg"
        >
          <EstudianteInfo :data="estudiante" />
        </b-modal>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import ExpedienteInfo from '@/components/expediente-info'
import EstudianteInfo from '@/components/estudiante-info'
import ExpedientePreguntarRazon from '@/components/expediente-preguntar-razon';
import constantes from "../../../config/Constantes";

/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Recepción de expedientes",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    Layout,
    PageHeader,
    ExpedienteInfo,
    ExpedientePreguntarRazon,
    EstudianteInfo
  },
  data() {
    return {
      razonRechazo:"",
      expedientes_tipos:[],
      title: "Recepción de expedientes",
      items: [
        {
          text: "Expedientes",
          href: "/"
        },
        {
          text: "Recepción",
          active: true
        }
      ],

      isLoading: false,
      columns: [
        {
          label: "Nº Exp",
          field: "numero_referencia"
        },
        {
          label: "Fecha",
          field: "fecha"
        },
        {
          label: "Origen",
          field:"oficina_origen"
        },
        {
          label: "Tramite",
          field:"tipo_expediente"
        },
        {
          label: "Nombre / Denominacion",
          field: "denominacion"
        },
        {
          label: "E.P.",
          field: "carrera"
        },
        {
          label: "Codigo",
          field: "codigo"
        },
        {
          label: "Dias",
          field: "dias",
          //formatFn: this.formatDias,
        },
        {
          label: "Archivos",
          field: "archivos"
        },
        {
          label: "Acciones",
          field: "acciones",
          width: '200px'
        }

      ],
      rows: [],
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: {
          field: "",
          type: ""
        },
        page: 1,
        perPage: 10
      },
      server: process.env.VUE_APP_BACKEND,
      modal:{},
      carreras_profesionales:[],
      estudiante:{},
      filtro:{
        expediente_tipo_id:null,
        codigo_carrera:null
      }
    };
  },

  methods: {
    formatDias(value){
      return  value + " Dias";
    },
    updateText(texto){
      console.log(texto);
      this.razonRechazo=texto;
    },
    recepcionarActual(value){
      var rows=Array();
      rows.push(value);
      this.recepecionar(rows);
    },

    recepcionarEnLote(){
      var rows=this.$refs["tblExpedientes"].selectedRows;
      this.recepecionar(rows);
    },
    recepecionar(rows_selected) {
      this.$swal
        .fire({
          title: "¿Esta seguro de recepcionar los expedientes?",
          text: "Debe revisar los expedientes antes de realizar esta accion.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#4049D8",
          cancelButtonColor: "#3085d6",
          confirmButtonText: "Si, Recepcionar",
          showLoaderOnConfirm: true
        })
        .then(result => {
          if (result.value) {
            this.isLoading = true;
            this.axios
              .post(
                process.env.VUE_APP_BACKEND + "/api/expedientes/recepcionar",
                {
                  rows: rows_selected
                }
              )
              .then(response => {
                if (response.data.success) {
                  this.$swal("OK", "Se recepciono los expedientes", "success");
                }
                else
                {
                  this.$swal("Error", "Se produjo un error recepcionando los expedientes.", "error");
                }
              })
              .catch(() => {
                this.$swal("error", "Error", "error");
              })
              .finally(() => {
                this.isLoading = false;
                this.loadItems();
              });
          }
        });
    },
    decimal(value) {
      if (value === null) {
        return "-";
      } else {
        return parseFloat(value).toFixed(2);
      }
    },
    borrar(id) {
      this.$swal
        .fire({
          title: "¿Esta seguro?",
          text: "No se puede revertir esta accion!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          confirmButtonText: "Si, borralo!"
        })
        .then(result => {
          if (result.value) {
            this.isLoading = true;
            this.axios
              .delete(process.env.VUE_APP_BACKEND + "/api/ubicacion/" + id)
              .catch(() => {
                this.$swal("error", "Error eliminando", "error");
              })
              .finally(() => {
                this.isLoading = false;
                this.loadItems();
              });
          }
        });
    },
    onSearch: function(params) {
      this.updateParams({ page: params.page });
      this.updateParams({ searchTerm: params.searchTerm });
      this.loadItems();
    },
    say: function(message) {
      alert(message);
    },
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },

    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.loadItems();
    },

    onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage });
      this.loadItems();
    },

    onSortChange(params) {
      this.updateParams({
        sort: [
          {
            type: params.sortType,
            field: this.columns[params.columnIndex].field
          }
        ]
      });
      this.loadItems();
    },

    onColumnFilter(params) {
      this.updateParams(params);
      this.loadItems();
    },
    // load items is what brings back the rows from server
    loadItems() {
      this.isLoading = true;
      this.serverParams.filtro=this.filtro;
      this.serverParams.orden="asc";
      this.serverParams.tipo_derivacion="0";
      this.serverParams.recepcionado="0";// AMBOS
      this.axios
        .get(process.env.VUE_APP_BACKEND + "/api/expedientes/tabla-recepcion", {
          params: this.serverParams
        })
        .then(response => {
          //console.log(response.data.data);
          this.totalRecords = response.data.total_records;
          this.rows = response.data.data;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
          //console.log(error);
        });
    },
    /* eslint-disable */
    onRowDoubleClick(params) {
      //this.$bvModal.show("modalExpediente");
      //this.mostrarModal(params.row.id);
    },
    mostrarModal(expediente_id){
      this.isLoading=true;
      this.axios.get( process.env.VUE_APP_BACKEND +'/api/expedientes/'+expediente_id)
              .then((response)=>{
                this.modal=response.data;
                this.$bvModal.show("modalExpediente");
              }).finally(()=>this.isLoading=false);
    },
    mostrarEstudiante(row){
      this.isLoading=true;
      this.estudiante={};
      this.axios.get(
              process.env.VUE_APP_BACKEND + "/api/estudiantes/buscar", {
                params: {
                  codigo:row.codigo,
                  codigo_carrera:row.codigo_carrera
                }
              }
      )
              .then((response)=>{
                this.estudiante=response.data;
                this.$bvModal.show("modalEstudiante");
              })
              .finally(()=>{
                this.isLoading=false;
              })
    },
    mostrarModalRechazo(expediente_id){
      this.isLoading=true;
      this.axios.get( process.env.VUE_APP_BACKEND +'/api/expedientes/'+expediente_id)
              .then((response)=>{
                this.modal=response.data;
                this.$bvModal.show("modalExpedientePreguntarRazon");
              }).finally(()=>this.isLoading=false);

    },
    rechazarAOficina(expediente_id) {
      if(this.razonRechazo=="") {

        this.$swal("!Cuidado¡", "Ingrese el motivo de rechazo.", "warning");
        return;
      }
      this.isLoading=true;
      this.axios.post( process.env.VUE_APP_BACKEND +'/api/expedientes/rechazar-a-oficina'
              ,{
                expediente_id:expediente_id,
                razon_rechazo:this.razonRechazo
              })
              .then((response)=>{
                if(response.data.success)
                {
                  this.$swal("Ok", "Se rechazo el expediente.", "success");
                  this.$bvModal.hide("modalExpedientePreguntarRazon");
                  this.loadItems();
                }
              })
              .catch((response) => {
                this.isLoading = false;
                this.$swal("!Cuidado¡", response.mensaje, "warning");
              })
              .finally(()=>this.isLoading=false);
    },
    rechazarAEstudiante(expediente_id) {
      if(this.razonRechazo=="") {

        this.$swal("!Cuidado¡", "Ingrese el motivo de rechazo.", "warning");
        return;
      }
      this.isLoading=true;
      this.axios.post( process.env.VUE_APP_BACKEND +'/api/expedientes/rechazar-a-estudiante'
              ,{
                expediente_id:expediente_id,
                razon_rechazo:this.razonRechazo
              })
              .then((response)=>{
                if(response.data.success)
                {
                    this.$swal("Ok", "Se rechazo el expediente.", "success");
                    this.$bvModal.hide("modalExpedientePreguntarRazon");
                    this.loadItems();
                }
              })
              .catch((response) => {
                this.isLoading = false;
                this.$swal("!Cuidado¡", response.mensaje, "warning");
              }).finally(()=>this.isLoading=false);
    }
    /* eslint-enable */
  },
  mounted() {

    this.axios.get(process.env.VUE_APP_BACKEND+'/api/expediente-tipo')
            .then((response)=>
            {
              this.expedientes_tipos=response.data;
              this.expedientes_tipos.unshift({
                id:0,
                descripcion:"(Todos)"
              });
              this.carreras_profesionales =JSON.parse(JSON.stringify(constantes.carreras_profesionales_habilitadas));// {... };
              this.carreras_profesionales.unshift({'codigo':0,'carrera':'(Todos)'});
              this.filtro.expediente_tipo_id=0;
              this.filtro.codigo_carrera=0;
              this.loadItems();
            })
            .finally(()=>{

            })
            .catch(()=>{

            })

  }
};
</script>

<style>
.fixfont {
  font-size: 12px !important;
  color: #000000 !important;
}
</style>
